import { colors } from "constants/theme"

export default function IconBack() {
    return (
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.21621 3.2807L3.68442 4.67845L2.86579 5.45865L0 2.72932L2.86579 0L3.68442 0.7802L2.21621 2.17794H6.36842C7.59679 2.17794 8.77485 2.64268 9.64344 3.46991C10.512 4.29713 11 5.4191 11 6.58897C11 7.75885 10.512 8.88081 9.64344 9.70804C8.77485 10.5353 7.59679 11 6.36842 11H1.15789V9.89724H6.36842C7.2897 9.89724 8.17324 9.54869 8.82469 8.92827C9.47613 8.30785 9.8421 7.46638 9.8421 6.58897C9.8421 5.71156 9.47613 4.87009 8.82469 4.24967C8.17324 3.62925 7.2897 3.2807 6.36842 3.2807H2.21621Z" fill={colors.themeSecondColor} />
        </svg>
    )
}